import { Bot, Department, User } from "@/domain/user";
import globalStore from "./store/globalStore";
import { FieldsTypeTask } from "@/domain/task";
import { FieldsType } from "@/domain/form";
import { CatalogListTypeOptionWithStringId } from "@/domain/catalog";
import { urlForDownload } from "./utils";
import AnonImg from "@/shared/assets/img/anon.png";

export function getUserById(id: number): User | null {
	const users = globalStore.getters.getUsers as User[];
	return users.find((user: User) => user.id === id) || null;
}

export function getBotById(id: number): Bot | null {
	const bots = globalStore.getters.getBots as Bot[];
	return bots.find((bot: Bot) => bot.id === id) || null;
}

export function getDepartmentById(id: number): Department | null {
	const departments = globalStore.getters.getDepartments as Department[];
	return departments.find((department: Department) => department.id === id) || null;
}

export function getFormFieldById(id: number) {
	const fields = globalStore.getters.getFormField as FieldsTypeTask[];
	const surfaceSearch = fields.find((field: FieldsTypeTask) => field.id === id);

	let returnValue: FieldsType | null = null;

	const findElWithRecursion = (el: FieldsType) => {
		if ("fields" in el) {
			el.fields?.map((item) => {
				if (item.id === id) {
					returnValue = item;
				} else {
					findElWithRecursion(item);
				}
			});
		} else {
			return;
		}
	};

	if (surfaceSearch) {
		return surfaceSearch;
	} else {
		// Поиск вложенного  элемента
		fields.forEach((el: FieldsType) => {
			// Если у родителя есть поле fields
			findElWithRecursion(el);
		});

		return returnValue;
	}
}

export function formatUsersToOptionType<T extends User | Bot | Department>(
	options: T[],
): CatalogListTypeOptionWithStringId[] {
	return options.map((option) => {
		if ("info" in option) {
			if ("name" in option.info) {
				return {
					label: `${option.info.name} ${option.info.surname ? option.info.surname : ""}`,
					value: `${option.id}user`,
					avatarUrl: option.avatar_url === null ? AnonImg : urlForDownload(`${option.avatar_url}`, 64),
					disabled: !option.enabled,
				};
			}
			return {
				label: `${option.info.bot_name}`,
				value: `${option.id}user`,
				avatarUrl: option.avatar_url === null ? AnonImg : urlForDownload(`${option.avatar_url}`, 64),
				disabled: !option.enabled,
			};
		}
		return {
			label: option.name,
			value: `${option.id}dep`,
			avatarUrl: option.avatar_url === null ? AnonImg : urlForDownload(`${option.avatar_url}`, 64),
		};
	});
}
